import React from 'react';
import styles from './ProgressBar.module.scss';

// 进度条，value 为 0-100
export default function ProgressBar ({value = 0, color = 'green', label, className = ''}) {
    const pct = Math.max(0, Math.min(100, value));
    return (
        <div className={[styles.wrap, className].filter(Boolean).join(' ')}>
            <div
                className={styles.track}
                role="progressbar"
                aria-valuenow={pct}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={label}
            >
                <div className={[styles.fill, styles[color]].join(' ')} style={{width: `${pct}%`}} />
            </div>
        </div>
    );
}
